import FormInputTypes from '../components/atoms/formEnums/formInputTypes';

export default {
  title: 'Purchase url',
  attributeName: 'purchaseUrl',
  fields: [
    {
      attributeName: 'purchaseUrl',
      helpText: 'Url to redirect user to with the buy ticket button in whitelabel web',
      type: FormInputTypes.TEXT_INPUT.URL,
      label: 'Purchase ticket url',
      placeholder: 'Write where to purchase ticket url...',
      default: null,
    },
  ],
};
